import { createFileRoute } from "@tanstack/react-router";

import ProductsPage from "@/features/public/pages/products";

export const Route = createFileRoute("/(public)/_public/products")({
  component: () => (
    <main role="main" aria-label="Products page content" className="min-h-screen w-full">
      <ProductsPage />
    </main>
  ),
});
